import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { IconBase } from '../internal/IconBase.js';
/**
 * `UserCheck` — user with check badge.
 *
 * Canonical use: user-account glyphs in profile, auth, access control.
 * Aria label:    User check
 * Family:        user-account
 * Related:       user, user-plus, user-minus, user-x, users, user-cog
 * Audited 2026-09-20 — no-op (5/5 criteria pass). User check.
 *
 */
export const UserCheck = forwardRef(function UserCheck(props, ref) {
    return (_jsxs(IconBase, { ref: ref, ...props, children: [_jsx("circle", { cx: "9", cy: "8", r: "4" }), _jsx("path", { d: "M3 21 a6 6 0 0 1 12 0" }), _jsx("path", { d: "M16 14 l2 2 4 -5" })] }));
});
//# sourceMappingURL=user-check.js.map